import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { MultiSelector } from '../models/selector/multi-selector-model';

@Component({
  selector: 'multi-selector',
  templateUrl: './multi-selector.component.html',
  styleUrls: ['./multi-selector.component.scss']
})
export class MultiSelectorComponent implements OnInit {

  public expandedKeys: any[] = [];
  public selectorOpened: boolean = false;
  @Input() selectedName: string = "Select";
  @Input() selectedId: number = 0;
  @Input() labelText: string;
  @Input() hoverText: string;
  @Input() isIncludeFloatLocation: boolean = true;
  @Input() includeInactive: boolean = false;
  @Input() enableAllNodes: boolean = false;
  @Input() public dataHierarchy: MultiSelector;
  @Input() public checkedKeys: any[] = [];
  @Input() selectorDisabled: boolean = false;
  @Input() displayName: string;
  @Input() searchKey: string;
  @Output() onData = new EventEmitter<MultiSelector>();
  @Output() onChange: EventEmitter<Array<any>> = new EventEmitter();
  selectedItems: Array<any> = [];

  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void {
    this.onData.emit(this.dataHierarchy);
    this.addExpandListItem(this.dataHierarchy.data);
    this.setDefaultValue(this.checkedKeys, this.dataHierarchy.data);
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      // clicked outside => close dropdown list
      this.selectorOpened = false;
    }
  }

  public closeDropDown() {
    this.selectorOpened = false;
  }

  public onItemSelected(data: any) {
    this.selectorOpened = false;
  }

  public setDefaultValue(checkedKeys: number[], items: Array<any>) {
    for (var i = 0; i < items.length; i++) {
      if (checkedKeys.indexOf(items[i].id) > -1) {
        if (items[i].isSelectable) {
          this.selectedItems.push(items[i]);
          this.setDefaultValue(checkedKeys, items[i].items)
        }
      }
      else {
        this.setDefaultValue(checkedKeys, items[i].items)
      }
    }
  }

  private addExpandListItem(treeItem: Array<any>) {
    treeItem.forEach(item => {
      if (item.items && item.items.length > 0) {
        this.expandedKeys.push(item.id);
        this.addExpandListItem(item.items)
      }
    });
  }

  public handleChange(data: any) {
    this.checkedKeys = data;
    let locationsFlatArray = this.dataHierarchy.flatData;
    let selectedLocatonsArray = locationsFlatArray.filter(item => data.indexOf(item.id) !== -1);
    this.selectedItems = selectedLocatonsArray;
    this.onChange.emit(this.selectedItems);
  }

  public locationClick() {
    this.selectorOpened = !this.selectorOpened;
  }

  public onRemove(item: any): void {
    const index = this.selectedItems.findIndex((c) => c.id === item.id);
    const checkedKeyIndex = this.checkedKeys.findIndex(k => k == item.id);
    this.checkedKeys.splice(checkedKeyIndex, 1);
    this.selectedItems.splice(index, 1);
    this.onChange.emit(this.selectedItems);
  }

}
